/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 1/14/14
 * Time: 5:02 PM
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var ContentCannedModel = require("content-models/canned/ContentCannedModel");
    var TabsBar = require("ui/tabsbar/TabsBar");
    var Button = require("ui/button/Button");
    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");
    var HotKeysCollection = require("content-collections/HotKeysCollection");

    var ContentCannedEditPageModel = {};

    //list of keys on the Content JSON instead of repeating strings everywhere
    var KEYS = {
        model: "model",
        languageTabCollection: "languageTabCollection",
        editType: "editType",
        header: "header",
        pageInfo: "pageInfo",
        pageInfoTotals: "pageInfo.totalPages",
        pageInfoCurrent: "pageInfo.currentPageNumber",
        pageInfoPrevious: "pageInfo.previousPageNumber",
        saveAllowed: "save.allowed",
        contentModelHasChanges: "save.modelChanged",
        saveAllowedTooltip: "save.tooltip",
        addLanguagesButton: "addLanguages",
        allowMiniErrors: "allowMiniErrors",
        inUseHotKeysCollection: "inUseHotKeysCollection"
    };

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentCannedEditPageModel = BaseModel.extend({
            languageContentMap: {},
            name: "ContentCannedEditPageModel",
            defaults: {
                model: null,
                languageTabCollection: null ,
                header: {
                    title: "",
                    description: ""
                },
                pageInfo: {
                    previousPageNumber : 0,
                    currentPageNumber: 0,
                    totalPages: 1
                },
                save:{
                    allowed: false,
                    modelChanged:false,
                    tooltip: ""
                }
            },

            initialize: function (options) {
                this.onClearEmptyCannedModel = new ContentCannedModel();
                this.set(KEYS.model,this.onClearEmptyCannedModel );
                this.set(KEYS.languageTabCollection,SelectableCollectionDecorator.decorate(new TabsBar.TabCollection()));
            },
            getModelData: function (){
                return this.getContentModel().getData();
            },
            setModelData: function(data, options){
                this.getContentModel().setData(data, options);

                _.each(this.languageCodes, function (lang, index, list) {
                    this._setHasContentFlagOnTab(lang);
                },this);
            },
            clear: function() {
                this.setSelectedLanguage(this.defaultSiteLang);
                this.setContentModel(this.onClearEmptyCannedModel);
            },
            isContentEmpty: function(){
                return this.getContentModel() ===  this.onClearEmptyCannedModel;
            },
            initLanguageTabs: function(){
                this.defaultSiteLang = LE.siteSettings.supportedLanguageSettings.getDefaultLanguage();
                this.languageCodes = LE.siteSettings.supportedLanguageSettings.getSupportedLanguageCodes();
                var that = this;
                var languageNamesTranslated = LE.siteSettings.supportedLanguageSettings.getAllLanguageNamesTranslated();
                var selectedLanguage = this.getSelectedLanguage();
                if(_.isUndefined(selectedLanguage)){
                    selectedLanguage = this.defaultSiteLang;
                }

                LEContent.logger.debug("Initializing languages","ContentCannedEditPageModel:initLanguageTabs");
                //Prepare the language tab array
                this.languageCodes = _.sortBy(this.languageCodes, function(languageCode){
                    return languageCode != this.defaultSiteLang;
                }, this);

                var languageTabs = {};

                if (LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.EDIT_CANNED, LE.sessionManager.PRIVILEGES.ADD_CANNED)) {
                    languageTabs[KEYS.addLanguagesButton] = new TabsBar.TabModel({
                        id: KEYS.addLanguagesButton,
                        tooltip: LE.translator.translate("LEContent.content.edit.add.languages.tab.tooltip"),
                        hasCheckbox: false,
                        hasContent: false,
                        isButton: true,
                        align: "right",
                        btnPermutation: Button.PERMUTATION.BTN_PLUS
                    });
                }

                _.each(this.languageCodes, function (code, index, list) {
                    //return tabs map
                    languageTabs[code] = new TabsBar.TabModel( {
                        id: code, //put the untranslated language string,
                        name: languageNamesTranslated[code],
                        hasCheckbox: false,
                        hasContent: that.getContentModel().hasContent(code),
                        align: "right"
                    });
                }, this);

                LEContent.logger.debug("instance tabs value","ContentCannedEditPageModel:initInstances",languageTabs);

                this.getLanguageTabCollection().reset(_.values(languageTabs));
                if(!languageTabs[selectedLanguage]) {
                    selectedLanguage = this.defaultSiteLang;
                }
                this.setSelectedLanguage(selectedLanguage);

            },
            /**
             * Find which languages has been added to the account supported languages - since the last time the tabs were initialized
             * @returns {Array}
             */
            getAddedLanguageCodes: function(){
                var siteLanguages = LE.siteSettings.supportedLanguageSettings.getSupportedLanguageCodes();
                var tabLanguages = this.getLanguageTabCollection().pluck("id");
                var missingLanguageCodes = [];

                _.each(siteLanguages, function (code, index, list){
                    if(!_.contains(tabLanguages, code)){
                        missingLanguageCodes.push(code);
                    }
                }, this);

                return missingLanguageCodes;
            },
            /**
             * Find which languages has been removed from the account supported languages  - since the last time the tabs were initialized
             * @returns {Array}
             * @private
             */
            getRemovedLanguageCodes: function(){
                var siteLanguages = LE.siteSettings.supportedLanguageSettings.getSupportedLanguageCodes();
                var tabLanguages = this.getLanguageTabCollection().pluck("id");
                var removedLanguageCodes = [];

                _.each(tabLanguages, function (code, index, list){
                    if(!_.contains(siteLanguages, code) && code !== KEYS.addLanguagesButton){
                        removedLanguageCodes.push(code);
                    }
                }, this);

                return removedLanguageCodes;
            },
            //site languages has been removed - remove them from the model
            deleteRemovedLanguagesData: function(removedLanguages){
                if(removedLanguages.length !== 0) {
                    var modelData = this.getModelData();
                    _.each(removedLanguages, function (code, index, list) {
                        modelData = _.reject(modelData, function (dataItem) {
                            return dataItem.lang === code;
                        });
                        if(code === this.getSelectedLanguage()){
                            this.setSelectedLanguage(this.defaultSiteLang);
                        }
                    }, this);
                    this.setModelData(modelData, {noSaveValidate: true});
                }
            },
            //site languages has been added - add to the model added data for each item if it exists
            appendAddedLanguagesData: function (updatedModel,missingLanguageCodes) {
                var modelDataArr = updatedModel.getData();
                var missingData = _.filter(modelDataArr, function(item){
                    return _.contains(missingLanguageCodes , item.lang);
                });
                var existingModelData = this.getModelData().concat(missingData);
                this.setModelData(existingModelData, {noSaveValidate: true});
            },

            setDefaultLanguageData: function(defaultDataArr){
                //remove defaults that are not in use in the UI
                var defaultDataForAvailableLanguages = _.filter(defaultDataArr, function(item){
                    return _.contains(this.languageCodes , item.lang);
                }, this);

                var modelData = this.getModelData();
                //remove those that have defaults
                _.each(defaultDataArr, function (defaultDataForAvailableLanguages, index, list) {
                    modelData = _.reject(modelData, function (dataItem) {
                        return dataItem.lang === defaultDataForAvailableLanguages.lang;
                    });
                }, this);

                var existingModelData = modelData.concat(defaultDataForAvailableLanguages);

                this.setModelData(existingModelData);
            },
            getContentHotKeys: function(){
                return this.getContentModel().getContentHotkeys();
            },
            getIsContentNew: function () {
                return this.get(KEYS.model).isNew();
            },
            getSelectedLanguage: function () {
                return this.getLanguageTabCollection().getSelectedId();
            },
            setSelectedLanguage: function (selectedLang) {
                this.getLanguageTabCollection().selectModel(selectedLang);
            },
            getContentDataKey: function(){
                return this.getContentModel().getContentDataKey();
            },
            getContentTitleKey: function(){
                return this.getContentModel().getContentTitleKey(this.getSelectedLanguage());
            },
            getContentMSGKey: function(){
                return this.getContentModel().getContentMSGKey(this.getSelectedLanguage());
            },
            setContentModel: function(model){
                model.setValidations();
                model.resetLanguageContentMap();
                this.stopListening(this.getContentModel());
                this.set(KEYS.saveAllowed,false);
                this.set(KEYS.contentModelHasChanges,false);
                this.set(KEYS.saveAllowedTooltip,model.saveNoChangesTooltip());
                this.setHeader(model.getHeaderTexts());
                this.set(KEYS.model,model);

                var info = LEContent.reqres.request("canned:content-edit:itemPagingInfo", model);
                this.set(KEYS.pageInfo, {
                    previousPageNumber: info.currentPageNumber,
                    currentPageNumber:  info.currentPageNumber,
                    totalPages: info.totalPages
                });
                this.listenTo(model,"change",this._validateSaveAllowed);

                this.initLanguageTabs();
            },

            _validateSaveAllowed: function (modelChanges, options) {
                if(!(options && options.noSaveValidate)) { //no save needed for site language changes
                    //need to compute is save allowed
                    //First if we arrived here its because we listen to model change - this means costumer did some changes so save is allowed on that aspect
                    this.set(KEYS.contentModelHasChanges, true);
                    //now lets check if the model is savable
                    var modelSavable = this.getContentModel().validateSaveEnabled();

                    if (modelSavable) {
                        this.set(KEYS.saveAllowed, true);
                        this.set(KEYS.saveAllowedTooltip, "");
                    } else {
                        this.set(KEYS.saveAllowed, false);
                        this.set(KEYS.saveAllowedTooltip, this.getContentModel().saveEmptyTooltip());
                    }
                }

            },
            validateContent: function() {
                return this.getContentModel().validateContent();
            },
            getContentModel: function(){
                return this.get(KEYS.model);
            },
            getLanguageTabCollection: function(){
                return this.get(KEYS.languageTabCollection);
            },
            getSelectedLanguageContentTitle: function(){
                return this.getContentModel().getContentTitle(this.getSelectedLanguage()) ;
            },
            getSelectedLanguageContentMessage: function(){
                return this.getContentModel().getContentMessage(this.getSelectedLanguage()) ;
            },

            setAllowMiniErrors: function(allowMiniErrors){
                this.set(KEYS.allowMiniErrors,allowMiniErrors);
            },
            setHeader: function(header){
                this.set(KEYS.header,header);
            },
            getHeader: function(){
                return this.get(KEYS.header);
            },
            setContentTitle: function(title){
                var selectedLanguage = this.getSelectedLanguage();
                this.getContentModel().setContentTitle(selectedLanguage,title);
                this._setHasContentFlagOnTab(selectedLanguage);
            },
            setContentMessage: function(message){
                var selectedLanguage = this.getSelectedLanguage();
                this.getContentModel().setContentMessage(selectedLanguage,message);
                this._setHasContentFlagOnTab(selectedLanguage);
            },
            _setHasContentFlagOnTab: function(lang){
                var tabModel = this.getLanguageTabCollection().findWhere({id: lang});
                tabModel.set("hasContent",this.getContentModel().hasContent(lang));
            },
            getContentMessage: function(){
               return this.getContentModel().getContentMessage(this.getSelectedLanguage());
            },
            getCategories: function() {
                return this.getContentModel().getCategories();
            },
            setCategories: function(categoriesArr) {
               this.getContentModel().setCategories(categoriesArr);
            },
            getSkills: function() {
                return this.getContentModel().getSkills();
            },
            setSkills: function(skillsArr) {
                this.getContentModel().setSkills(skillsArr);
            },
            getLobs: function() {
                return this.getContentModel().getLobs();
            },
            setLobs: function(lobsArr) {
                this.getContentModel().setLobs(lobsArr);
            },
            isMismatchLobsAndSkills: function(skillsCollection) {
                return this.getContentModel().isMismatchLobsAndSkills(skillsCollection);
            },
            getEnabledState: function(){
                return this.getContentModel().getEnabledState();
            },
            setEnabledState: function(state){
                this.getContentModel().setEnabledState(state);
            },
            isEnabledEditable: function(){
                return this.getContentModel().isEnabledEditable();
            },
            hasTitleField: function() {
                return this.getContentModel().hasTitleField();
            },
            setCannedContentHotKeys: function(hotkeys){
                this.getContentModel().setContentHotkeys(hotkeys);
            },
            hasRestoreToDefault: function(){
                return !_.isUndefined(this.getTemplateId()) && !_.isNull(this.getTemplateId()) ;
            },
            getTemplateId: function(){
                return this.getContentModel().getTemplateId();
            },
            getContentPageInfoTotal: function(){
                return this.get(KEYS.pageInfoTotals);
            },

            getContentPageInfoCurrentPage: function(){
                return this.get(KEYS.pageInfoCurrent);
            },
            getContentPageInfoPreviousPage: function(){
                return this.get(KEYS.pageInfoPrevious);
            },
            setContentPageInfoCurrentPage: function(currentPageIdx){
                this.set(KEYS.pageInfoPrevious,this.getContentPageInfoCurrentPage());
                this.set(KEYS.pageInfoCurrent,currentPageIdx);
            },
            revertContentPageNumberChange: function() {
                this.set(KEYS.pageInfoCurrent,this.getContentPageInfoPreviousPage());
            },
            getAllowedMacros: function(){
                return this.getContentModel().getAllowedMacros();
            },
            getAllContentMacros: function(){
                return this.onClearEmptyCannedModel.getAllowedMacros();
            },
            hasChanges: function(){
                return this.get(KEYS.contentModelHasChanges);
            },
            getIsSaveAllowed: function(){
                return this.get(KEYS.saveAllowed);
            },
            getIsSaveAllowedTooltipKey: function(){
                return this.get(KEYS.saveAllowedTooltip);
            },
            getModelID: function(){
                return this.getContentModel().get("id");
            },
            _setInUseHotKeysCollection: function(inUseHotKeysCollection){
                this.set(KEYS.inUseHotKeysCollection, inUseHotKeysCollection);
            },
            getInUseHotKeysCollection: function(){
                return this.get(KEYS.inUseHotKeysCollection);
            },
            fetchInUseHotKeysCollection: function(success, error){
                var that = this;
                var inUseHotKeysCollection = new HotKeysCollection();
                inUseHotKeysCollection.fetch({
                    success: function(collection, response, options) {
                        LEContent.logger.debug("fetch content in use hotkeys success ", "ContentCannedEditPageModel:getInUseHotKeysCollection");
                        if (_.isFunction(success)){
                            that._setInUseHotKeysCollection(collection);
                            success();
                        }
                    },
                    error: function(model, response, options) {
                        LEContent.logger.debug("fetch content in use hotkeys error.", "ContentCannedEditPageModel:getInUseHotKeysCollection");
                        if (response && response.responseError && !_.isEmpty(response.responseError.message)) {
                            LEContent.notifier.showError({content: response.responseError.message, timeToShow: 6000});
                        }
                        that._setInUseHotKeysCollection(null);
                        if (_.isFunction(error)){
                            error();
                        }
                    }
                });

            },
            getAvailableLetterHotKeys: function(exisitingLetter) {
                return this.getInUseHotKeysCollection().getAvailableLetterHotKeys(exisitingLetter);
            },
            getAvailableNumberHotKeys: function(letter, exisitingNumber) {
                return this.getInUseHotKeysCollection().getAvailableNumberHotKeys(letter, exisitingNumber);
            }
        });
    });

    ContentCannedEditPageModel.KEYS = KEYS;

    return ContentCannedEditPageModel;
});
